import React, { useState } from 'react';
import Input from '@ntuctech/devex-tangram/Input';
import Grid from '@ntuctech/devex-tangram/Grid';
import styled from 'styled-components';
import { Typography, SvgMinus, SvgAdd, ButtonIcon } from '@ntuctech/devex-tangram';

const StyledIconButton = styled(ButtonIcon)`
  display: inline-block;
  margin: 0;
  width: 2rem;
  height: 2rem;
  svg {
    top: 0.25rem;
  }
  svg path {
    fill: ${(p) => (p.disabled ? '#cccccc' : '#fff')} !important;
  }
  :hover {
    background: #104393 !important;
  }
  :focus {
    background-color: #0b2e65;
    ::before {
      box-shadow: none;
    }
  }
  &:active {
    background-color: #0b2e65;
    ::before {
      box-shadow: none;
    }
  }
`;

const RmvInnerPadRecipientDetail = styled.div`
  div {
    padding: 0 0 !important;
  }
  @media screen and (max-width: 1262px) and (min-width: 1024px) {
    > div > div:nth-child(1) > div {
      padding-right: 5px !important;
    }
    > div > div:nth-child(2) > div {
      padding-left: 5px !important;
    }
  }
  @media screen and (min-width: 1262px) {
    > div > div:nth-child(1) > div {
      padding-right: 10px !important;
    }
    > div:nth-child(2) > div {
      max-width: 338px;
    }
  }
`;
const H6Title = styled.h6`
  margin: 0px;
  padding-top: 15px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
`;
const RmvButtonShow = styled.span`
  cursor: pointer;
  color: #1454b8;
  font-size: 1rem;
  line-height: 1.5rem;
  display: block;
  text-align: right;
  font-weight: 700;
  position: relative;
  top: 15px;
`;
const InputSection = styled.div`
  > div:hover input {
    border-color: #666666 !important;
  }
  > div:hover label {
    color: inherit !important;
  }
  > div input:hover {
    border-color: #1454b8 !important;
  }
  > div {
    margin-bottom: 0;
    width: 100%;
    margin-top: 15px;
  }
  > div div {
    width: 100%;
  }
  input {
    max-width: 328px;
    margin: 0 auto 0 0;
    :-webkit-autofill,
    :-webkit-autofill:hover,
    :-webkit-autofill:focus,
    :-webkit-autofill:active {
      box-shadow: 0 0 0 30px white inset !important;
    }
  }
  input[type='date'] {
    width: 167px;
  }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
  @media screen and (max-width: 768px) {
    input {
      max-width: 100%;
    }
  }
`;

export const PlusMinusInput = styled.div`
  margin-top: ${(p) => (p.isBusiness ? 0 : '15px')};
  button {
    padding: 0;
    background: ${(p) => (p.isAdd ? '#fff' : '#1557bf')};
    color: #ffffff;
    border-radius: 50%;
    height: 32px;
    width: 32px;
    font-weight: bold;
    font-size: 20px;
    position: relative;
    padding-bottom: 2px;
    top: ${(p) => (p.isBusiness ? '-0.438rem' : '0.313rem')};
    border: none;
    &:disabled {
      background: ${(p) =>
        p.isBusiness || p.isDisabled ? '#f2f2f2 !important' : '#a3c2f5 !important'};
      border: none;
    }
  }

  #input-wrap {
    margin: 0px;
    padding: 0px;
  }

  #number {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    width: 40px;
    height: 32px;
    background: #f3f5f7;
    border: 1px solid #eaeaea;
    box-sizing: border-box;
    border-radius: 2px;
    margin: 0 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #1557bf;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  div {
    margin: 0;
    color: #666666;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    display: block;
    margin-bottom: 10px;
  }
  svg {
    position: relative;
    top: 0.188rem;
  }
  svg path {
    fill: #333333;
  }
`;
export const ValueButton = styled.button`
  display: inline-block;
  margin: 0px;
  width: 32px;
  height: 32px;
  text-align: center;
  vertical-align: middle;
  padding: 11px 0;
  background: #eee;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
`;
const BottomLine = styled.div`
  background: #eaeaea;
  flex: none;
  order: 2;
  flex-grow: 0;
  margin: 24px 0px;
  height: 1px;
`;

const StyledGrid = styled(Grid)`
  padding: 0 !important;
  .input-field {
    margin: 0 0.75rem !important;
    width: 3.5rem !important;
    border-radius: 0.25rem !important;
    border: 0.063rem !important;
    padding: 0.25rem 0.5rem !important;
    color: #1454b8 !important;
    top: -0.5rem;
  }
`;

const AddReceipnt = (props) => {
  const { recData, recepient, index, setRecepient, voucherData, setVoucherData, counterInputRef } =
    props;
  const [isError, setError] = useState(false);
  const [nameError, setNameError] = useState(false);

  /* eslint-disable no-useless-escape */
  const emailFormat =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      recData.email
    );

  const phoneFormat = /^(?:\+65)?[689][0-9]{7}$/.test(recData.phone);

  const handleChange = (name, value) => {
    recepient[index] = {
      ...recepient[index],
      [name]: value,
    };
    setRecepient([...recepient]);
    setVoucherData({ ...voucherData, receivers: recepient });
  };

  const onKeyUp = (event) => {
    const fixedNumber = event.currentTarget;
    const fixedValue = fixedNumber.getAttribute('data-fixedvalue');
    if (fixedNumber.value.indexOf(fixedValue) !== 0) {
      fixedNumber.value = fixedValue;
      recepient[index] = {
        ...recepient[index],
        [event.target.name]: event.target.value,
      };
      setRecepient([...recepient]);
      setVoucherData({ ...voucherData, receivers: recepient });
      event.preventDefault();
    }
  };

  const onKeyDown = (event) => {
    if (event.keyCode === 8 && event.target.value === '+65') {
      event.preventDefault();
    }
  };

  const handleRemove = () => {
    const spliceaddrecepient = [...recepient];
    spliceaddrecepient.splice(index, 1);
    setRecepient(spliceaddrecepient);
    setVoucherData({ ...voucherData, receivers: spliceaddrecepient });
  };

  const getHelperTextEmail = () => {
    if (recData.email !== '') {
      return !emailFormat ? 'Enter a valid email address' : 'Maximum length 255';
    }
    return 'Maximum length 255';
  };

  const getHelperTextMobile = () => {
    if (recData.phone !== '' && recData.phone !== '+65') {
      return !phoneFormat ? 'Enter a valid mobile number' : 'Maximum length 20';
    }
    return 'Maximum length 20';
  };

  const getHelperTextname = () => {
    return 'Maximum length 36';
  };

  /* eslint-disable no-unused-expressions */
  const handleOnBlur = (name, value) => {
    if (name === 'name') {
      value !== '' ? setNameError(value.length > 36) : setNameError(false);
    }
    if (name === 'email') {
      value !== '' ? setError(!emailFormat) : setError(false);
    }
    if (name === 'phone') {
      value !== '' && value !== '+65' ? setError(!phoneFormat) : setError(false);
    }
  };

  return (
    <React.Fragment key={recData}>
      <RmvInnerPadRecipientDetail>
        <Grid container>
          {/* <Grid item xs={10}> */}
          <Grid item xs={9}>
            <H6Title>Recipient {index + 1}</H6Title>
          </Grid>
          {recepient.length > 1 && (
            // <Grid item xs={2}>
            <Grid item xs={3}>
              <RmvButtonShow data-testid="removeButton" onClick={() => handleRemove()}>
                Remove
              </RmvButtonShow>
            </Grid>
          )}
        </Grid>
        <Grid container>
          <Grid item m={6}>
            <InputSection>
              <Input
                data-testid={`recipient-name-${index}`}
                label="Name "
                type="text"
                required
                placeholder="Enter name"
                name="name"
                ref={counterInputRef}
                maxLength={36}
                tabindex="-3"
                error={nameError}
                helpText={getHelperTextname()}
                value={recData.name}
                onChange={(event) => handleChange(event.target.name, event.target.value)}
                onBlur={(event) => handleOnBlur(event.target.name, event.target.value)}
              />
            </InputSection>
          </Grid>
          <Grid item m={6}>
            {recData.deliveryMethod === 'email' ? (
              <InputSection>
                <Input
                  data-testid={`recipient-email-${index}`}
                  label="Email address"
                  type="text"
                  required
                  maxLength={255}
                  name="email"
                  placeholder="Enter email"
                  tabindex="-2"
                  ref={counterInputRef}
                  value={recData.email ? recData.email : ''}
                  onChange={(event) => handleChange(event.target.name, event.target.value)}
                  helpText={getHelperTextEmail()}
                  error={isError}
                  onBlur={(event) => handleOnBlur(event.target.name, event.target.value)}
                />
              </InputSection>
            ) : (
              <InputSection>
                <Input
                  data-testid={`recipient-mobile-no-${index}`}
                  label="Recipient's mobile number"
                  type="tel"
                  required
                  maxLength={20}
                  data-fixedvalue="+65"
                  name="phone"
                  tabIndex="-2"
                  ref={counterInputRef}
                  value={recData.phone ? recData.phone : ''}
                  onChange={(event) => handleChange(event.target.name, event.target.value)}
                  onKeyDown={(event) => onKeyDown(event)}
                  onKeyUp={(event) => onKeyUp(event)}
                  helpText={getHelperTextMobile()}
                  error={isError}
                  onBlur={(event) => handleOnBlur(event.target.name, event.target.value)}
                />
              </InputSection>
            )}
          </Grid>
        </Grid>
      </RmvInnerPadRecipientDetail>
      <PlusMinusInput isDisabled={recData.count >= 1000 || recData.count <= 1}>
        <div>
          <Typography variant="bodySBold">Quantity of vouchers</Typography>
        </div>
        <StyledGrid>
          <StyledIconButton
            id="decrease"
            onClick={() => {
              handleChange('count', recData.count - 1);
            }}
            data-testid={`decrementButton-${index}`}
            disabled={recData.count <= 1}
          >
            <SvgMinus />
          </StyledIconButton>
          <input
            className="input-field"
            type="number"
            required
            id="number"
            data-testid={`inc-dec-input-${index}`}
            placeholder="0"
            min={0}
            ref={counterInputRef}
            value={recData.count}
            onChange={(event) => handleChange(event.target.name, event.target.value)}
            name="count"
          />
          <StyledIconButton
            id="increase"
            onClick={() => {
              handleChange('count', Number(recData.count) + 1);
            }}
            data-testid={`incrementButton-${index}`}
            disabled={recData.count >= 1000}
          >
            <SvgAdd />
          </StyledIconButton>
        </StyledGrid>
      </PlusMinusInput>
      <BottomLine />
    </React.Fragment>
  );
};

export default AddReceipnt;
